// @flow
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'

import { useTranslation } from '../../../hooks'
import { HISTORY } from '../../../utils'

function BrowseStores({ observeBackHistory }) {
	const translate = useTranslation()

	const moveBackwards = () => {
		if (observeBackHistory) {
			HISTORY.goBack()
		} else {
			window.location = process.env.REACT_APP_BSECURE_CUSTOMER_APP_URL
		}
	}

	return (
		<>
			<div className="dropdown browseStores">
				<div className="nav-link" onClick={moveBackwards}>
					<span className="text-default">
						<span onClick={moveBackwards}>{translate('BREADCRUMB.BROWSE')}</span>
					</span>
				</div>
			</div>
		</>
	)
}

export default BrowseStores
